import { useEffect, useRef, useState } from "react";
import useGet from "../useGet";
import toast from "react-hot-toast";
import useCreate from "../useCreate";

const useUploadProductFile = ({ onClose } = {}) => {
	const { setDataToServer: previewProductFile } = useCreate({
		url: "direct_product_excel_preview",
		stringifyValues: false,
		onError: (err) => {
			toast.error(err.response?.data?.message || "Could not read Excel columns");
		},
	});

  const { setDataToServer } = useCreate({
    url: "direct_product_excel_upload",
    refreshUrl: "product_excel_upload_listing",
    stringifyValues: false,
    onSuccess: (data) => {
      onClose?.();
      toast.success(data?.message || "File queued for import");
    },
    onError: (err) => {
      const data = err.response?.data;
      const rowErrors = data?.errors
        ?.map((error) => `Row ${error.row}: ${error.fields.join(", ")}`)
        .join("\n");
      toast.error(rowErrors || data?.message || "File upload failed");
    },
  });

  const uploadProductFile = (file, brandId, columnMapping, uploadId) => {
    setDataToServer.mutate({
      excel_file: file,
      brand_id: brandId,
	  column_mapping: JSON.stringify(columnMapping || {}),
	  ...(uploadId ? { upload_id: uploadId } : {}),
    });
  };

	const previewExcelFile = (file) => {
		previewProductFile.mutate({ excel_file: file });
	};

  //   Brands dropdown code
  const [brandOptions, setBrandOptions] = useState([]);
  const [brandHasMore, setBrandHasMore] = useState(true);
  const [brandPageNo, setBrandPageNo] = useState(0);
  const [brandId, setBrandId] = useState(null);

  const {
    data: brandData,
    setParamsObject: setBrandParams,
    data: brandQuery,
  } = useGet({
    url: "brand/list",
    initialParams: {
      pageNo: 0,
      limit: 10,
      searchQuery: "",
    },
    onSuccess: (response) => {
      const formattedOptions =
        response?.data?.map((brand) => ({
          value: brand.brand_id,
          label: brand.name,
        })) || [];

      if (brandPageNo === 0) {
        setBrandOptions([
          //   { value: "", label: "All Brands" },
          ...formattedOptions,
        ]);
      } else {
        setBrandOptions((prev) => [...prev, ...formattedOptions]);
      }

      setBrandHasMore(
        formattedOptions.length > 0 &&
          response?.totalCount > brandOptions.length
      );
    },
    onError: (err) => {
      console.error("Brand fetch error:", err);
    },
  });

  // Function to fetch brands with pagination and search
  const fetchBrands = (query = "", reset = false) => {
    const pageToFetch = reset ? 0 : brandPageNo;

    if (reset) {
      setBrandPageNo(0);
      setBrandOptions([]);
    }

    setBrandParams({
      pageNo: pageToFetch,
      limit: 10,
      searchQuery: query,
    });

    if (!reset) {
      setBrandPageNo((prev) => prev + 1);
    }
  };

  // Handle brand selection
  const handleBrandSelect = (brandIdParam) => {
    setBrandId(brandIdParam);
  };

  //   Code to download template

  const { setDataToServer: downloadTemplateReq } = useCreate({
    url: "direct_product_excel_templete_download",
    responseAsBlob: true,
    onSuccess: (data) => {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "product_template.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    },
    onError: (err) => {
      toast.error("Template download failed: " + err.response?.data?.message);
    },
  });
  const isDownloading = downloadTemplateReq.isLoading;

  const toastId = useRef(null);

  useEffect(() => {
    if (isDownloading) {
      toastId.current = toast.loading("Downloading report...");
    } else {
      toast.dismiss(toastId.current);
    }

    return () => {
      if (toastId.current) toast.dismiss(toastId.current); // Clean up on unmount or state change
    };
  }, [isDownloading]);

  const downloadTemplate = (brandId) => {
    downloadTemplateReq.mutate({
      brand_id: brandId,
    });
  };

  return {
    brandOptions,
    brandHasMore,
    fetchBrands,
    brandQuery,
    brandId,
    handleBrandSelect,
    uploadProductFile,
	previewExcelFile,
	previewProductFile,
	uploadRequest: setDataToServer,
    downloadTemplate,
  };
};

export default useUploadProductFile;
